module.exports = __webpack_public_path__ + "img/new-baleno-2023.5b457aab.png";